import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export const FETCH_SIMPLE_PRODUCT_REQUEST = 'FETCH_SIMPLE_PRODUCT_REQUEST';
export const FETCH_SIMPLE_PRODUCT_SUCCEEDED = 'FETCH_SIMPLE_PRODUCT_SUCCEEDED';
export const FETCH_SIMPLE_PRODUCT_FAILED = 'FETCH_SIMPLE_PRODUCT_FAILED';
export type SimpleProductAction = ActionType<typeof actions>;
